import Markdown from "react-markdown";

interface props {
  content: string;
  className?: string;
  fallback?: React.ReactNode;
}

const SafeMarkdown = ({ content, className, fallback }: props) => {
  try {
    return (
      <Markdown
        className={className}
        components={{
          p: ({ children }) => <p className="tw-leading-8">{children}</p>,
          strong: ({ children }) => (
            <span className="tw-font-bold tw-text-fay-500">{children}</span>
          ),
          ul: ({ children }) => (
            <ul className="tw-my-4 tw-ml-4 tw-flex tw-list-disc tw-flex-col tw-gap-2">
              {children}
            </ul>
          ),
          ol: ({ children }) => (
            <ol className="tw-my-4 tw-ml-4 tw-list-decimal">{children}</ol>
          ),
        }}
      >
        {content}
      </Markdown>
    );
  } catch (e) {
    return (
      fallback || (
        <div className="tw-whitespace-pre-wrap tw-font-medium">{content}</div>
      )
    );
  }
};

export default SafeMarkdown;
